import React from "react";
import SectionHeader from "../../components/ui/HeaderSection";
import PlainNavbar from "../../components/layout/PlainNavbar";
import termsContent from "./TermsContent";

const TermsOfService = () => {
  return (
    <>
      <PlainNavbar />
      <div className="flex min-h-screen font-montserrat">
        {/* Sidebar */}
        <aside className="w-1/4 bg-gray-100 px-6 py-24 hidden lg:block">
          <h3 className="font-bold text-lg mb-4">List</h3>
          <ul className="space-y-2 text-sm text-gray-700">
            {termsContent.map((section) => (
              <li key={section.id} className="pl-3 py-1">
                <a
                  href={`#${section.id}`}
                  className="hover:text-blue-500 transition"
                >
                  <span className="font-bold">{section.number} </span>
                  {section.title}
                </a>
              </li>
            ))}
          </ul>
        </aside>

        {/* Main Content */}
        <main className="flex-1 ml-20 my-28 pr-20">
          <SectionHeader
            title="Terms Of Service"
            description="Terakhir diupdate pada MM YYYY"
            TitleColor="#010203"
            DescriptionColor="#ABABAB"
            textAlign="left"
          />

          {/* TOS Content */}
          <div className="mt-6 space-y-8">
            {termsContent.map((section) => (
              <section key={section.id} id={section.id} className="space-y-3">
                <h2 className="font-bold text-lg text-gray-900">
                  <span className="mr-1">{section.number}</span> {section.title}
                </h2>
                <ul className="list-disc pl-5 text-gray-700 text-sm">
                  {section.content.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </section>
            ))}
          </div>
        </main>
      </div>
    </>
  );
};

export default TermsOfService;
